
import React from 'react';
import { CardContent, CardHeader, CardTitle, Card } from "@/components/ui/card";

export const NotLoggedInMessage = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Matching Candidates</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground text-center py-4">
          Please log in to see matching candidates.
        </p>
      </CardContent>
    </Card>
  );
};
